import { AbstractService } from "./abstract.service";
import { Message } from 'element-ui'
export class StorageService extends AbstractService {
  static get entity() {
    return "nsh/odm/api";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  // tồn kho - lấy thông tin phiếu order theo id
  static async storageGetInfoOrderById(params) {
    try {
      const response = await this.callApi().get(`${this.entity}/order/io/${params.id}`)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return this.errorWrapper(error, message);
    }
  }
  // tồn kho - check in order
  static async storageCheckInOrder(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/order/io/create-check-in-order`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return this.errorWrapper(error, message);
    }
  }
  // tồn kho - balance order
  static async storageBalanceOrder(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/order/io/create-balance-order`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return this.errorWrapper(error, message);
    }
  }

  // tồn kho - Cập nhật trạng thái
  static async storageChangeStatus(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/order/io/change-status`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return this.errorWrapper(error, message);
    }
  }

  // tồn kho - tạo mới check out order
  static async storageCheckoutOrder(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/order/io/create-check-out-order`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return this.errorWrapper(error, message);
    }
  }

  // tồn kho - tìm kiếm
  static async storageSearch(params) {
    try {
      const response = await this.callApi().post(`${this.entity}/order/io/search`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return this.errorWrapper(error, message);
    }
  }

  // tồn kho - cập nhật order
  static async storageUpdateOrder(params) {
    try {
      const response = await this.callApi().put(`${this.entity}/order/io/update`, params)
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return error;
    }
  }
}